var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceCities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35450_206969)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1615 10.5808C16.6893 10.3168 17.3107 10.3168 17.8385 10.5808L22.8323 13.0776C22.9379 13.1304 23.0621 13.1304 23.1677 13.0776L27.0365 11.1433C28.2832 10.5199 29.75 11.4265 29.75 12.8203V25.3047C29.75 26.0149 29.3487 26.6642 28.7135 26.9818L23.8385 29.4193C23.3107 29.6832 22.6893 29.6832 22.1615 29.4193L17.1677 26.9224C17.0621 26.8696 16.9379 26.8696 16.8323 26.9224L12.9635 28.8568C11.7168 29.4801 10.25 28.5736 10.25 27.1797V14.6953C10.25 13.9851 10.6513 13.3359 11.2865 13.0183L16.1615 10.5808ZM17 14C17.4142 14 17.75 14.3358 17.75 14.75V23C17.75 23.4142 17.4142 23.75 17 23.75C16.5858 23.75 16.25 23.4142 16.25 23V14.75C16.25 14.3358 16.5858 14 17 14ZM23.75 17C23.75 16.5858 23.4142 16.25 23 16.25C22.5858 16.25 22.25 16.5858 22.25 17V25.25C22.25 25.6642 22.5858 26 23 26C23.4142 26 23.75 25.6642 23.75 25.25V17Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35450_206969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCities);
export default __webpack_public_path__ + "static/media/service-cities.d9ba9413cc491cb8d666315055148223.svg";
export { ForwardRef as ReactComponent };